import { Routes, Route } from 'react-router-dom';
import Profile from './components/Profile';
import Interests from './pages/Interests';
import Story from './pages/Story';
import StoryDetails from './pages/StoryDetails';
import Challenges from './pages/Challenges';
import WishDetails from './pages/WishDetails';
import AdminLogin from './pages/AdminLogin';
import CreateStory from './pages/CreateStory';
import ImagePreview from './pages/ImagePreview';
import Playlists from './pages/Playlists';
import { useTheme } from './context/ThemeContext';

function App() {
  const { dark, toggleColorMode, designMode, setDesignOverride, isDesignOverridden, isAdmin } = useTheme();

  return (
    <div className="relative min-h-screen w-full font-sans transition-colors bg-latte-base dark:bg-mocha-base overflow-hidden">
      {/* Global dark/light mode switch */}
      <div className="fixed top-6 right-8 z-50 flex flex-col items-end gap-2">
        <label className="relative inline-flex items-center cursor-pointer w-16 h-9">
          <input
            type="checkbox"
            checked={dark}
            onChange={toggleColorMode}
            className="sr-only peer"
            aria-label="Toggle dark mode"
          />
          <span
            className={`absolute inset-0 rounded-full transition-colors duration-300 border border-white/20 ${dark ? 'bg-[#232634]' : 'bg-[#f9e2af]'}`}
            style={{ boxShadow: '0 2px 8px 0 rgba(0,0,0,0.10)' }}
          />
          {dark
            ? <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[#fab387] text-xl pointer-events-none">🌙</span>
            : <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[#dca561] text-xl pointer-events-none">☀️</span>
          }
          <span
            className={`
              absolute top-1 left-1 h-7 w-7 rounded-full shadow transition-transform duration-300
              ${dark ? 'translate-x-7 bg-[#181825]' : 'translate-x-1 bg-white'}
            `}
            style={{ zIndex: 1 }}
          />
        </label>

        {/* New / Old design switch - visitors may override for their own view */}
        <div
          className="flex items-center gap-1 rounded-full bg-white/70 dark:bg-[#232634]/80 backdrop-blur-md shadow px-1 py-1 text-xs font-bold border border-white/30 dark:border-[#45475a]/60"
          role="group"
          aria-label="Pilih tampilan New atau Old"
        >
          <button
            type="button"
            onClick={() => setDesignOverride('classic')}
            className={`px-3 py-1 rounded-full transition-colors ${designMode === 'classic' ? 'bg-[#b4befe] text-[#232634]' : 'text-[#6c6f85] dark:text-[#a6adc8] hover:text-[#232634] dark:hover:text-white'}`}
          >
            Old
          </button>
          <button
            type="button"
            onClick={() => setDesignOverride('modern')}
            className={`px-3 py-1 rounded-full transition-colors ${designMode === 'modern' ? 'bg-[#89b4fa] text-[#181825]' : 'text-[#6c6f85] dark:text-[#a6adc8] hover:text-[#232634] dark:hover:text-white'}`}
          >
            New
          </button>
          {isDesignOverridden && !isAdmin && (
            <button
              type="button"
              onClick={() => setDesignOverride(null)}
              title="Ikuti tampilan default situs"
              className="px-2 py-1 rounded-full text-[#6c6f85] dark:text-[#a6adc8] hover:text-[#232634] dark:hover:text-white"
            >
              ↺
            </button>
          )}
        </div>
      </div>
      {/* Main content */}
      <div className="relative z-10">
        <Routes>
          <Route path="/" element={<Profile dark={dark} setDark={() => toggleColorMode()} />} />
          <Route path="/interests" element={<Interests dark={dark} />} />
          <Route path="/story" element={<Story />} />
          <Route path="/story/:maskedId" element={<StoryDetails />} />
          <Route path="/challenges" element={<Challenges />} />
          <Route path="/wish/:maskedId" element={<WishDetails />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/create-story" element={<CreateStory />} />
          <Route path="/preview/:id" element={<ImagePreview />} />
          <Route path="/playlists" element={<Playlists />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;